<template>
  <div class="prr-page">
    <VContainer class="prr-content py-12 py-md-16 px-6">
      <h1 class="prr-title">#Construir o Futuro</h1>

      <h2 class="prr-company">Dreamdeal Technologies, Unipessoal, Lda</h2>

      <p>
        O projeto consiste no desenvolvimento de um ERP em modelo SaaS para o
        setor da construção civil, permitindo a digitalização e centralização dos
        fluxos de informação entre a produção e a gestão.
      </p>

      <p>
        <strong>OBJETIVO:</strong> Promoção de modelos de negócio, Produtos ou
        serviços digitais com contributo positivo para a transição climática
        através de elevada eficiência na utilização de recursos.
      </p>

      <p class="prr-investment">
        <strong>INVESTIMENTO: 30.000,00 €</strong>
      </p>
    </VContainer>

    <!-- Barra dos logótipos: fica imediatamente antes do Footer global -->
    <div class="prr-funding-bar">
      <a
        href="https://recuperarportugal.gov.pt/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Plano de Recuperação e Resiliência - Recuperar Portugal"
        class="prr-funding-link"
      >
        <img
          :src="prrLogos"
          alt="PRR, República Portuguesa e União Europeia - NextGenerationEU"
          class="prr-logos"
        >
      </a>
      <a
        href="/documents/ficha-operacao-prr-dreamdeal.pdf"
        target="_blank"
        rel="noopener noreferrer"
        class="prr-document-link"
        aria-label="Consultar ficha de operação PRR (PDF)"
      >
        <VIcon small class="mr-2">mdi-file-pdf-box</VIcon>
        Consultar ficha de operação PRR (PDF)
        <VIcon x-small class="ml-1">mdi-open-in-new</VIcon>
      </a>
    </div>
  </div>
</template>

<script>
import prrLogos from '@/assets/p2020/BARRA_FINANCIAMENTO/PNG/BARRA_LOGOS-03.png'

export default {
  name: 'PRR',
  data() {
    return { prrLogos }
  }
}
</script>

<style scoped>
.prr-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: calc(100vh - 104px);
  min-height: calc(100dvh - 104px);
  background: #fff;
  color: #3c4149;
}

.prr-content {
  flex: 1 0 auto;
  width: 100%;
  max-width: 960px;
}

.prr-title {
  color: #24643c;
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  font-weight: 800;
  margin-bottom: 2rem;
}

.prr-company {
  font-size: clamp(1.1rem, 2vw, 1.35rem);
  font-weight: 700;
  margin-bottom: 2rem;
}

.prr-content p {
  font-size: 1.05rem;
  line-height: 1.8;
  margin-bottom: 1.75rem;
}

.prr-investment {
  margin-top: 2rem;
}

.prr-funding-bar {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 24px 16px;
  background: #fff;
}

.prr-funding-link {
  display: block;
  width: 100%;
  max-width: 540px;
  line-height: 0;
}

.prr-logos {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}
.prr-document-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 14px;
  color: #285d43;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  text-decoration: underline;
}
.prr-document-link:hover { color: #173b2a; }
</style>
